// src/api/axiosInstance.js

import axios from 'axios';
import Swal from 'sweetalert2';

// Use the same base URL as your components
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
    baseURL: API_BASE_URL
});

// Interceptor 1: Automatically add Auth Token to every request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor 2: Handle global errors, especially 401 Unauthorized
axiosInstance.interceptors.response.use(
    // If response is successful, just return it
    (response) => {
        return response;
    },
    // If response has an error, check for 401
    (error) => {
        if (error.response && error.response.status === 401) {
            // Token is invalid or expired
            localStorage.removeItem('adminToken');

            Swal.fire({
                title: 'Session Expired',
                text: 'Your session has expired. Please log in again.',
                icon: 'warning',
                confirmButtonText: 'OK'
            }).then(() => {
                // Use window.location to force a full page refresh and clear any state
                window.location.href = '/admin';
            });
        }

        // For all other errors, just pass them along to the component's catch block
        return Promise.reject(error);
    }
);

export default axiosInstance;